import { client, useApiGet } from "./_base";

export interface ProductCharacteristics {
  id?: number;
  characteristic_code: string;
  characteristic_description: string;
  labelinggroup_id: number;
  paltrack_label_processed: number;
  created_at: Date;
  updated_at: Date;
  // These are for the old fields - which will be removed again
  product_group_code: string;
  product_characteristic_code: string;
  product_characteristic_description: string;
}

interface ProductCharacteristicsFull extends ProductCharacteristics {
  group_code: string;
  group_description: string;
}

const endpoint = "productcharacteristics";

export const productcharacteristics = client<ProductCharacteristics>(endpoint, (item) => ({
  ...item,
}));

export const getProductCharacteristicsFull = async (): Promise<ProductCharacteristicsFull[]> => useApiGet(`${endpoint}/ext/all`);
